import { Link } from "react-router";
import { SearchX } from "lucide-react";
import BasicLayout from "@/layouts/basic-layout";
import { ActionButton } from "@/dev/ui/verify-footer";
import SEO from "@/components/SEO";

export default function NotFoundPage() {
  return (
    <BasicLayout>
      <SEO
        title="הדף לא נמצא – 404"
        description="הדף שחיפשת לא נמצא. חזור לדף הבית או נסה לחפש שוב."
        noindex
      />
      <main className="flex-grow text-black">
        <div className="container mx-auto py-16 flex flex-col items-center justify-center">
          <SearchX className="h-24 w-24 text-[#b65bf3] mb-6" />
          <h1 className="text-4xl font-bold mb-4">404 – הדף לא נמצא</h1>
          <p className="text-xl mb-8 text-center max-w-md">
            הדף שחיפשת לא קיים או שהועבר. אנא חזור לדף הבית.
          </p>
          <div className="flex gap-4">
            <Link to="/">
              <ActionButton>חזרה לדף הבית</ActionButton>
            </Link>
            <Link to="/login">
              <ActionButton color="gray">התחברות</ActionButton>
            </Link>
          </div>
        </div>
      </main>
    </BasicLayout>
  );
}
